import type { CreatedProduct } from '@/types/products'

/**
 * The "Associated Form" cell: the form a product was made in, with the repeat
 * number when its step repeats ("Collection #2"), so two products made in
 * different performances of the same form are told apart. Null when the
 * server could not name the form.
 */
export function associatedFormLabel(p: Pick<CreatedProduct, 'associatedForm'>): string | null {
  const form = p.associatedForm
  if (!form?.name) return null
  return form.repeatIndex == null ? form.name : `${form.name} #${form.repeatIndex}`
}

/**
 * Where a product's patient link goes, or null for a product with no patient
 * (a kit). The label is the name, falling back to the MRN.
 */
export function productPatientLink(
  p: Pick<CreatedProduct, 'patientMrn' | 'patientName'>,
): { to: string; label: string } | null {
  const mrn = p.patientMrn?.trim()
  if (!mrn) return null
  return { to: `/patients/${encodeURIComponent(mrn)}`, label: p.patientName?.trim() || mrn }
}
